import { Button, Card } from 'antd';
import { UsDateformat } from '../../utilities/extensions';
import { PatientDetailsResponse } from '../../models/PatientModels';
import { useNavigate } from 'react-router-dom';
import { ReactNode } from 'react';

const PatientInformationHeader = ({
    patient,
    children,
    navigate,
    isPatientDashboardVisible = true,
}: {
    patient: PatientDetailsResponse;
    children?: ReactNode;
    navigate: () => void;
    isPatientDashboardVisible?: boolean;
}) => {
    return (
        <Card className='max-w-750'>
            <div className="patient-team d-flex flex-row align-items-center justify-content-between">
                <div className="d-flex align-items-end gap-2 ms-4">
                    <span className="label ">
                        {patient.demographics.firstName}{' '}
                        {patient.demographics.lastName}
                    </span>
                    <span className="team-name">
                        DOB: {UsDateformat(patient.demographics.dateOfBirth)}
                    </span>
                </div>
                <div className="d-flex align-items-center gap-3">
                    {children}
                    {isPatientDashboardVisible && (
                        <Button
                        onClick={navigate}
                        style={{
                            color: 'var(--hcrx-light-blue)',
                            borderColor: 'var(--hcrx-light-blue)',
                        }}
                        shape="round"
                    >
                        Patient Dashboard
                    </Button>
                    )}
                    
                </div>
            </div>
        </Card>
    );
};

export default PatientInformationHeader;
